import React, { useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { useForm, useFormValidation } from '../../../hooks';
import { useMotivo } from '../hooks/useMotivo';
import { useCitaNueva } from '../hooks/useCitaNueva';
import { useRemove } from '../hooks/useRemove';

import { DateInput, Error, Forbidden, LightButton, Loader, NumberInput, PrimaryButton, ReactSelectSingleKeyInput, TextAreaInput, TextInputPreview, TimeInput } from '../../../components';

import { eliminarUndefined } from '../../../helpers/eliminarUndefined';

import styles from '../CitaPendiente.module.css';

export const CitaCreate = ({ cita }) => {

    let { id: notificacionId } = useParams();

    const navigate = useNavigate();

    const { permisos } = useSelector(state => state.auth);

    const [inactivoFlag, setInactivoFlag] = useState(false);
    const [horarioFlag, setHorarioFlag] = useState(false);
    const [empalmadaFlag, setEmpalmadaFlag] = useState(false);

    const activeInactivoFlag = () => {
        setInactivoFlag(true);
    }

    const activeHorarioFlag = () => {
        setHorarioFlag(true);
    }

    const activeEmpalmadaFlag = () => {
        setEmpalmadaFlag(true);
    }

    const { createCitaMutation: { mutate: createCita } } = useCitaNueva();

    const { removeMutation: { mutate: remove } } = useRemove();

    const { motivoQuery: { isLoading, isError, data: motivos } } = useMotivo();

    const { fecha, hora, motivo, comentario, onInputChange, onResetForm } = useForm({ fecha: (typeof cita !== 'undefined' && cita !== null && typeof cita.fecha !== 'undefined') ? cita.fecha : '', hora: (typeof cita !== 'undefined' && cita !== null && typeof cita.hora !== 'undefined') ? cita.hora : '', motivo: (typeof cita !== 'undefined' && cita !== null && typeof cita.motivo !== 'undefined') ? cita.motivo._id : '', comentario: (typeof cita !== 'undefined' && cita !== null && typeof cita.comentario !== 'undefined') ? cita.comentario : '' });

    const { duracion, onInputChange: onInputChangeSecond, onResetForm: onResetFormSecond } = useForm({ duracion: (typeof cita !== 'undefined' && cita !== null && typeof cita.duracion !== 'undefined') ? cita.duracion : 0 });

    const { isFormValid, formValidationStatus, formFields, startFormValidation, setFormFieldValidation, onResetValidation } = useFormValidation([{field: 'fecha', default: (typeof cita !== 'undefined' && cita !== null && typeof cita.fecha !== 'undefined') ? true : false}, {field: 'hora', default: (typeof cita !== 'undefined' && cita !== null && typeof cita.hora !== 'undefined') ? true : false}, {field: 'motivo', default: (typeof cita !== 'undefined' && cita !== null && typeof cita.motivo !== 'undefined') ? true : false}, {field: 'comentario', default: true}]);
    
    const { isFormValid: isFormValidSecond, formValidationStatus: formValidationStatusSecond, formFields: formFieldsSecond, startFormValidation: startFormValidationSecond, setFormFieldValidation: setFormFieldValidationSecond, onResetValidation: onResetValidationSecond } = useFormValidation([{field: 'duracion', default: true}]);

    const handleMotivoChange = (e) => {
        setInactivoFlag(false);
        setHorarioFlag(false);
        setEmpalmadaFlag(false);
        onInputChange(e);

        onInputChangeSecond({ target: { name: 'duracion', value: motivos.find(motivo => String(motivo._id) === String(e.target.value)).duracion } });
    }

    const handleInputChange = (e) => {
        setInactivoFlag(false);
        setHorarioFlag(false);
        setEmpalmadaFlag(false);
        onInputChange(e);
    }

    const handleInputChangeSecond = (e) => {
        setInactivoFlag(false);
        setHorarioFlag(false);
        setEmpalmadaFlag(false);
        onInputChangeSecond(e);
    }

    const handleSuccessSubmit = () => {
        onResetForm();
        onResetValidation();
        onResetFormSecond();
        onResetValidationSecond();
        remove({ id: notificacionId });
    }

    const handleCancelar = () => {
        navigate('/');
    }

    const onSubmit = async ( event ) => {
        event.preventDefault();

        if(formValidationStatus === 'checked' && isFormValid != null && isFormValid && formValidationStatusSecond === 'checked' && isFormValidSecond != null && isFormValidSecond){
            createCita({ data: eliminarUndefined({ paciente: cita.paciente, fecha, hora, motivo, duracion, comentario, citaPendiente: cita._id, inactivoConfirmacion: inactivoFlag, horarioConfirmacion: horarioFlag, empalmadaConfirmacion: empalmadaFlag }, { comentario: undefined }), onSuccess: handleSuccessSubmit, onComplete: handleCancelar, onInactivo: activeInactivoFlag, onHorario: activeHorarioFlag, onEmpalmada: activeEmpalmadaFlag});
        }else{
            startFormValidation();
            startFormValidationSecond();
        }

    }

    return (permisos.citaCreate) ? (
        <>
        {(isLoading)
            ? <Loader />
            : <>
                {(isError)
                    ? <Error />
                    : <>
                        <div>
                            <form onSubmit={ onSubmit }>
                                <div className="row">
                                    <div className="col">
                                        <TextInputPreview
                                            label="Paciente"
                                            name="paciente"
                                            value={cita.nombrePaciente}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-6">
                                        <DateInput
                                            formFieldStatus={ formFields['fecha'].status }
                                            label="Fecha"
                                            name="fecha"
                                            onChange={ handleInputChange }
                                            required={ true }
                                            requiredIndicator={ true }
                                            setFormFieldValidation={ setFormFieldValidation }
                                            value={ fecha }
                                        />
                                    </div>
                                    <div className="col-6">
                                        <TimeInput
                                            formFieldStatus={ formFields['hora'].status }
                                            label="Hora"
                                            name="hora"
                                            onChange={ handleInputChange }
                                            required={ true }
                                            requiredIndicator={ true }
                                            setFormFieldValidation={ setFormFieldValidation }
                                            value={ hora }
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-6">
                                        <ReactSelectSingleKeyInput
                                            formFieldStatus={ formFields['motivo'].status }
                                            label="Motivo"
                                            name="motivo"
                                            onChange={ handleMotivoChange }
                                            required={true}
                                            requiredIndicator={true}
                                            setFormFieldValidation={ setFormFieldValidation }
                                            value={motivo}
                                            values={motivos.map(motivo => ({ value: motivo._id, label: motivo.nombre }))}
                                        />
                                    </div>
                                    <div className="col-6">
                                        <NumberInput
                                            formFieldStatus={ formFieldsSecond['duracion'].status }
                                            label="Duración (min)"
                                            name="duracion"
                                            onChange={ handleInputChangeSecond }
                                            required={ true }
                                            requiredIndicator={ true }
                                            setFormFieldValidation={ setFormFieldValidationSecond }
                                            value={ duracion }
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col">
                                        <TextAreaInput
                                            formFieldStatus={ formFields['comentario'].status }
                                            label="Comentario"
                                            name="comentario"
                                            onChange={ handleInputChange }
                                            required={ false }
                                            requiredIndicator={ false }
                                            setFormFieldValidation={ setFormFieldValidation }
                                            value={ comentario }
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col">
                                        {(inactivoFlag) && <p className={styles.helperErrorText}>La fecha seleccionada esta marcada como día inactivo en la configuración del consultorio. ¿Deseas continuar igualmente?</p>}
                                        {(horarioFlag) && <p className={styles.helperErrorText}>El periodo de tiempo seleccionado esta fuera del horario configurado para el consultorio. ¿Deseas continuar igualmente?</p>}
                                        {(empalmadaFlag) && <p className={styles.helperErrorText}>El periodo de tiempo seleccionado se empalma con otra cita previamente agendada. ¿Deseas continuar igualmente?</p>}
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-xs-12 col-sm-12 col-md-6">
                                        <LightButton
                                            block={true}
                                            icon="X"
                                            marginTop={false}
                                            onClick={ handleCancelar }
                                            text="Cancelar"
                                            type="button"
                                        />
                                    </div>
                                    <div className='col-xs-12 col-sm-12 col-md-6'>
                                        <PrimaryButton
                                            block={true}
                                            disabled={formValidationStatus === 'checking'}
                                            icon="Check"
                                            marginTop={false}
                                            text={(inactivoFlag || horarioFlag || empalmadaFlag) ? "Confirmar" : "Crear"}
                                            type="submit"
                                        />
                                    </div>
                                </div>
                            </form>
                        </div>
                    </>
                }
            </>
        }
        </>
    ) : <Forbidden />
}
